export const pxToVw = (px) => {
  return (px / 375) * 100 + 'vw'
}
